import * as types from './types';

const INITIAL_STATE = {
  //dropdown items
  dropdownItems: [],
  loadingDropdownItems: false,
  loadingDropdownItemsError: null,

  //sites
  sitesData: [],
  loadingSitesData: false,
  loadingSitesDataError: null,

  //print
  emptyPrintResponse: null,
  loadingPrint: false,
  loadingPrintError: null,
  printData: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    //dropdown items
    case types.TRANSACTION_HISTORY_REPORT_DROPDOWN_ITEMS_LOADING:
      return {
        ...state,
        loadingDropdownItems: action.payload,
      };

    case types.TRANSACTION_HISTORY_REPORT_DROPDOWN_ITEMS:
      return {
        ...state,
        dropdownItems: action.payload,
      };

    case types.TRANSACTION_HISTORY_REPORT_DROPDOWN_ITEMS_LOADING_ERROR:
      return {
        ...state,
        loadingDropdownItemsError: action.payload,
      };

    case types.TRANSACTION_HISTORY_REPORT:
      return {
        printData: action.payload,
      };

    //sites
    case types.TRANSACTION_HISTORY_REPORT_SITES_LOADING:
      return {
        ...state,
        loadingSitesData: action.payload,
      };

    case types.TRANSACTION_HISTORY_REPORT_SITES:
      return {
        ...state,
        sitesData: action.payload,
      };

    case types.TRANSACTION_HISTORY_REPORT_SITES_LOADING_ERROR:
      return {
        ...state,
        loadingSitesDataError: action.payload,
      };

    //print
    case types.TRANSACTION_HISTORY_REPORT_PRINT_LOADING:
      return {
        ...state,
        loadingPrint: action.payload,
      };

    case types.TRANSACTION_HISTORY_REPORT_PRINT_LOADING_ERROR:
      return {
        ...state,
        loadingPrintError: action.payload,
      };

    case types.TRANSACTION_HISTORY_REPORT_EMPTY_RESPONSE:
      return {
        ...state,
        emptyPrintResponse: '',
      };

    case types.RESET_TRANSACTION_HISTORY_PRINT_RESPONSE:
      return {
        ...state,
        emptyPrintResponse: null,
      };

    case types.CLEAR_REPORT_ERROR:
      return {
        ...state,
        loadingDropdownItemsError: null,
        loadingSitesDataError: null,
        loadingPrintError: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/transactionhistoryreport/state/reducer.js